"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pullOsceStationQueryBuilder = exports.pullQuestionQueryBuilder = exports.pullTopicQueryBuilder = void 0;
const REPLICATION_LIMIT = 5;
const topicReplicationQuery = `query TopicReplication($lastId: String!, $minUpdatedAt: Int!, $limit: Int!){
  topicReplication(lastId: $lastId, minUpdatedAt: $minUpdatedAt, limit: $limit) {
    id
    updatedAt
    name
    totalQuestions
    correctQuestions
    incorrectQuestions
    totalCards
    ConfidentCards
    ReviewCards
    LearnCards
    deleted
  }
}`;
const pullTopicQueryBuilder = (doc) => {
    return {
        query: topicReplicationQuery,
        variables: {
            lastId: doc?.id ? doc.id.toString() : '0',
            minUpdatedAt: doc?.updatedAt ? doc.updatedAt : 0,
            limit: REPLICATION_LIMIT,
        },
    };
};
exports.pullTopicQueryBuilder = pullTopicQueryBuilder;
const questionReplicationQuery = `query QuestionReplication($lastId: String!, $minUpdatedAt: Int!, $limit: Int!){
  questionReplication(lastId: $lastId, minUpdatedAt: $minUpdatedAt, limit: $limit) {
    id
    __typename
    createdAt
    updatedAt
    typeId
    topic {
      id
      __typename
      name
      typeId
    }
    conceptId
    concept {
      id
      __typename
      createdAt
      updatedAt
      name
      chapterId
      topicId
    }
    question
    explanation
    totalVotes
    choices {
      id
      __typename
      questionId
      name
      explanation
      label
      answer
      votes
      picture {
        id
        createdAt
        updatedAt
        name
        caption
        path
        path512
        path256
        thumbhash
      }
    }
    pictures {
      id
      __typename
      pictureId
      questionId
      choiceId
      picture {
        id
        __typename
        createdAt
        updatedAt
        name
        caption
        path
        path512
        path256
        thumbhash
        topicId
      }
    }
    difficulty
    elo
    psaSectionId
  }
}`;
const pullQuestionQueryBuilder = (doc) => {
    return {
        query: questionReplicationQuery,
        variables: {
            lastId: doc?.id ? doc.id.toString() : '0',
            minUpdatedAt: doc?.updatedAt ? doc.updatedAt : 0,
            limit: REPLICATION_LIMIT,
        },
    };
};
exports.pullQuestionQueryBuilder = pullQuestionQueryBuilder;
const osceStationReplicationQuery = `query OsceStationReplication($lastId: String!, $minUpdatedAt: Int!, $limit: Int!){
  topicReplication(lastId: $lastId, minUpdatedAt: $minUpdatedAt, limit: $limit) {
    id
    updatedAt
    deleted
    name
    osceType {
      id
      name
      # user-specific keys
      # completed
      # total
      # avgScore
    }
    difficulty
    candidateBrief
    examinerBrief
    actorBrief
    explanation
    marks {
      id
      index
      osceStationId
      header
      name
    }
    topics {
      ...TopicFields
    }
    candidatePictures {
      ...PictureFields
    }
    actorPictures {
      ...PictureFields
    }
    exmainerPictures {
      ...PictureFields
    }
    walkthroughPictures{
      ...PictureFields
    }

    # user-specific keys
    # lastOsceMarksheetId
    # score
  }

  fragment PictureFields on OscePicture {
    id
    osceStationId
    pictureId
    picture {
      id
      createdAt
      updatedAt
      name
      caption
      path
      path512
      path256
      thumbhash
      topicId
      topic {
        ...TopicFields
      }
    }
  }
  fragment TopicFields on Topic {
    id
    name
    typeId
  }
}`;
const pullOsceStationQueryBuilder = (doc) => {
    return {
        query: osceStationReplicationQuery,
        variables: {
            lastId: doc?.id ? doc.id.toString() : '0',
            minUpdatedAt: doc?.updatedAt ? doc.updatedAt : 0,
            limit: REPLICATION_LIMIT,
        },
    };
};
exports.pullOsceStationQueryBuilder = pullOsceStationQueryBuilder;
